import React from "react";
import { Container, Typography } from "@mui/material";
import UserCard from "./Components/UserCard/UserCard";
import Pagination from "@mui/material/Pagination";
import styles from "./Intervenants.module.css";
import ScrollToTop from "../../../Utils/ScrollToTop";
import { useTranslation } from "react-i18next";

export default function Intervenants(props) {
  const { t } = useTranslation();

  // S'assurer que props.users est toujours un tableau
  const users = props.users || [];

  return (
    <Container>
      <ScrollToTop />

      <div className={styles["userCards"]}>
        {users.length > 0 ? (
          users
            .slice((props.currentPage - 1) * 6, props.currentPage * 6)
            .map((user) => <UserCard key={user.id_user} user={user} />)
        ) : (
          <Typography>{t("intervenantsnouser.noUsers", "No intervenants found")}</Typography>
        )}
      </div>

      {users.length > 0 && (
        <div className={styles["paginationContainer"]}>
          <Pagination
            count={Math.ceil(users.length / 6)}
            page={props.currentPage}
            onChange={props.handlePageChange}
            style={{ marginTop: "3%" }}
          />
        </div>
      )}
    </Container>
  );
}